import './home.scss';

import React from 'react';
// import { Link } from 'react-router-dom';
import { Translate } from 'react-jhipster';
import { Alert, Col, Row } from 'reactstrap';
import { QRCodeCanvas } from 'qrcode.react';

import { useAppSelector } from 'app/config/store';

export const Home = () => {
  const account = useAppSelector(state => state.authentication.account);

  const buildQRCode = () => {
    let port = window.location.port;
    if (port.length === 0) {
      if (window.location.protocol.startsWith('https')) {
        port = '443';
      } else {
        port = '80';
      }
    }
    return [
      'ORGA-SOFT Coop Webservice',
      `${window.location.protocol}//${window.location.host.split(':')[0]}`,
      port,
      '',
      '',
      '',
      '',
      '',
      '',
    ].join(';');
  };

  return (
    <Row>
      {/*
      <Col md="3" className="pad">
        <span className="hipster rounded" />
      </Col>
*/}
      <Col md="9">
        <h1 className="display-4">
          <Translate contentKey="home.title">Welcome to the ORGA-SOFT Coop Webservice!</Translate>
        </h1>
        <p className="lead">
          <Translate contentKey="home.subtitle">
            This web service of the ORGA-SOFT Cooperation provides central endpoints for INTEGRA. These can be used for the development of a
            wide range of applications, including web-based applications.
          </Translate>
        </p>
        {account?.login && ( // custom modification
          <div>
            <Alert color="success">
              <Translate contentKey="home.logged.message" interpolate={{ username: account.login }}>
                You are logged in as user {account.login}.
              </Translate>
            </Alert>
          </div>
          /* custom removal
        ) : (
          <div>
            <Alert color="warning">
              <Translate contentKey="global.messages.info.authenticated.prefix">If you want to </Translate>

              <Link to="/login" className="alert-link">
                <Translate contentKey="global.messages.info.authenticated.link"> sign in</Translate>
              </Link>
              <Translate contentKey="global.messages.info.authenticated.suffix">
                , you can try the default accounts:
                <br />- Administrator (login=&quot;admin&quot; and password=&quot;admin&quot;)
                <br />- User (login=&quot;user&quot; and password=&quot;user&quot;).
              </Translate>
            </Alert>

            <Alert color="warning">
              <Translate contentKey="global.messages.info.register.noaccount">You do not have an account yet?</Translate>&nbsp;
              <Link to="/account/register" className="alert-link">
                <Translate contentKey="global.messages.info.register.link">Register a new account</Translate>
              </Link>
            </Alert>
          </div>
*/
        )}
        <p>
          {/* custom modification
          <Translate contentKey="home.question">If you have any question on JHipster:</Translate>
*/}
          <Translate contentKey="home.login-qr">Login to the backend with the QR-Code</Translate>
        </p>
        {/* custom addition */}
        <QRCodeCanvas
          size={300}
          value={buildQRCode()}
          imageSettings={{ src: 'content/images/os-logo-short.png', height: 100, width: 100, excavate: true }}
          level="H"
        />

        {/* custom removal
        <ul>
          <li>
            <a href="https://www.jhipster.tech/" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.homepage">JHipster homepage</Translate>
            </a>
          </li>
          <li>
            <a href="https://stackoverflow.com/tags/jhipster/info" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.stackoverflow">JHipster on Stack Overflow</Translate>
            </a>
          </li>
          <li>
            <a href="https://github.com/jhipster/generator-jhipster/issues?state=open" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.bugtracker">JHipster bug tracker</Translate>
            </a>
          </li>
          <li>
            <a href="https://gitter.im/jhipster/generator-jhipster" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.chat">JHipster public chat room</Translate>
            </a>
          </li>
          <li>
            <a href="https://twitter.com/jhipster" target="_blank" rel="noopener noreferrer">
              <Translate contentKey="home.link.follow">follow @jhipster on Twitter</Translate>
            </a>
          </li>
        </ul>

        <p>
          <Translate contentKey="home.like">If you like JHipster, do not forget to give us a star on</Translate>{' '}
          <a href="https://github.com/jhipster/generator-jhipster" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
          !
        </p>
*/}
      </Col>
    </Row>
  );
};

export default Home;
